import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UsuariosProvider } from '../../providers/usuarios/usuarios'
import { CompaniasUsuariosProvider } from '../../providers/companias-usuarios/companias-usuarios'
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { UtilsProvider } from '../../providers/utils/utils'
import { Storage } from '@ionic/storage'
import { NUBE_AWS } from '../../config/url.servicio';

@IonicPage()
@Component({
  selector: 'page-companias-usuarios',
  templateUrl: 'companias-usuarios.html',
  providers: [ AuthService ]
})
export class CompaniasUsuariosPage {
  usuarios:any[]=[]
  companiasId:any = null
  companias:any[]=[]
  companiaUsuarios:any[]=[]

  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""

  constructor(public navCtrl: NavController, public navParams: NavParams,
              public servicioUsuarios:UsuariosProvider,
              public servicoCompaniaUsuarios:CompaniasUsuariosProvider,
              public servicioCompania:CompaniasProvider,
              public auth:AuthService,
              public mensaje:UtilsProvider,
              public storages:Storage
            ) {
                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                  }
                })

  }

  ionViewDidLoad() {
    this.buscarCompaniaUsuarios()
  }
  buscarCompaniaUsuarios(){
    this.storages.get('companiasId').then((val)=>{
      this.servicoCompaniaUsuarios.buscarUsuariosCompanias(val)
      .subscribe((data)=>{
        if(NUBE_AWS) {
          this.companiaUsuarios = JSON.parse(data['_body']).data[0] === undefined ? [] : JSON.parse(data['_body']).data[0]
        } else {
          this.companiaUsuarios = data
        }
      })
      let compania = parseInt(this.companiasId)
      this.servicioUsuarios.buscarUsuariosCompanias(val)
      .subscribe((data) => {
        if(NUBE_AWS) {
          this.usuarios = JSON.parse(data['_body']).data[0] === undefined ? [] : JSON.parse(data['_body']).data[0]
        } else {
          this.usuarios = data
        }
      }, error => {
        console.log(error)
      })
    })
  }

  guardar(){

    let data = {}
    data['queHago'] = "I"
    data['name'] = "dataDynamicCrud"
    data['nombreTabla'] = "usuariosCompanias"
    data['usuariosId'] =  parseInt(this.usuarios['usuariosId'])
    data['companiasId'] =  parseInt(this.companiasId)
    let users = this.usuarios['usuariosId']
    if(users ===undefined){
      this.mensaje.mensajeMuestro('NEGOCIOS USUARIOS','Debe seleccionar un usuario','warning')
      return false
    }
    this.storages.get('companiasId').then((val) => {
      data['companiasId'] =  val
    this.servicoCompaniaUsuarios.guardarUsuariosCompanias(data)
    .subscribe(
      res => {
        this.usuarios['usuariosId'] = ''
        this.buscarCompaniaUsuarios()
        this.mensaje.mensajeMuestro('Negocios Usuarios','Registro almacenado con Éxito!','success')
      },
      err => {

        console.log(err)
      }
    )
    })
  }

  eliminar(items:any){
    console.log(items)
    this.mensaje.mensajeConfirmacionDos('Negocios Usuarios','¿Está Seguro de borrar el registro?','question','Si','No')
    .then((loQueEscogio:boolean) =>{
      if (loQueEscogio){
        let data = {}
        data['usuariosCompaniasId'] = items.usuariosCompaniasId
        data['queHago'] = "E"
        data['name'] = "dataDynamicCrud"
        data['nombreTabla'] = "usuariosCompanias"
        this.servicoCompaniaUsuarios.eliminarUsuariosCompanias(data)
        .subscribe((data)=>{
          this.buscarCompaniaUsuarios()
          this.mensaje.mensajeMuestro('Negocios Usuarios','Registro eliminado con Éxito!','success')
        },
          error =>{
            console.log(error)
          })
      }
      else {
        this.mensaje.mensajeMuestro('Negocios Usuarios','No se eliminó el registro','warning')
      }

    })



  }
  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/companias-usuarios/companias-usuarios.ts